import DOMPurify from 'dompurify';
import { useCallback, useMemo, useRef } from 'react';
import ReactQuill from 'react-quill';
import { EditableField } from '../../../../../commonComponents/EditableField';
import { jobDescriptionMinLength, JobStatus } from '../../../shared/constants';
import { FormCard } from '../../../shared/FormCard';

export const JobDescriptionCard = ({
  formValues,
  isEditing,
  job,
  handleChange,
  onCancelClick,
  onEditClick,
  onSaveClick,
}) => {
  const controller = useRef();
  const timeoutRef = useRef(null);

  const isFormValid = useMemo(
    () => !!formValues.jobDescription.text,
    [formValues.jobDescription.text],
  );

  const handleTextChanged = useCallback(
    (content, delta, source, editor) => {
      // Clear previous timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Debounce the state update to avoid cursor position issues
      timeoutRef.current = setTimeout(() => {
        const sanitizedContent = DOMPurify.sanitize(content);
        const plainText = editor.getText().trim();
        handleChange('jobDescription', {
          raw: sanitizedContent,
          text: plainText,
        });
      }, 100);
    },
    [handleChange],
  );

  return (
    <FormCard title="Job Description" required={isEditing} style={{ marginTop: '16px' }}>
      <EditableField
        editing={isEditing}
        view={
          <div className="ql-snow" style={{ width: '90%', alignSelf: 'center' }}>
            <div
              className="ql-editor"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job?.description) }}
            />
          </div>
        }
        edit={
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <ReactQuill
              ref={controller}
              value={formValues.jobDescription?.raw}
              onChange={handleTextChanged}
              theme="snow"
              placeholder="Job Description"
              modules={{
                toolbar: [['bold', 'italic']],
              }}
            />
            <span style={{ color: '#999999' }}>{jobDescriptionMinLength} Character Min</span>
          </div>
        }
      />

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
        {isEditing ? (
          <div style={{ display: 'flex', alignSelf: 'center', gap: 10 }}>
            <button
              type="button"
              className="btn btn-danger"
              style={{ width: 100 }}
              onClick={onCancelClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info"
              style={{ width: 100 }}
              onClick={onSaveClick}
              disabled={!isFormValid}
            >
              Save
            </button>
          </div>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {![JobStatus.CLOSED, JobStatus.SUSPENDED].includes(job?.status) && (
              <button
                type="button"
                className="btn btn-info"
                style={{ width: 150, alignSelf: 'center' }}
                onClick={onEditClick}
              >
                Edit
              </button>
            )}
          </>
        )}
      </div>
    </FormCard>
  );
};
